import { render, staticRenderFns } from "./DoctorSelect.vue?vue&type=template&id=578db095"
import script from "./DoctorSelect.vue?vue&type=script&lang=js"
export * from "./DoctorSelect.vue?vue&type=script&lang=js"
import style0 from "./DoctorSelect.vue?vue&type=style&index=0&id=578db095&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports